import { EditorState } from 'draft-js';

import { editorStateChanged } from '../../../../components/editor/store/editorActions';
import {
    getEditorId,
    getEditorState,
    getOriginalEditorIdSelector,
} from '../../../../components/editor/store/reducers/editorStoreSelector';

/**
 * Forces a collapse of the current text selection in the DraftJS editor
 * @returns true if the action was handled
 */
export const collapseTextEditorRange =
    () =>
    (dispatch: Function, getEditorStoreState: Function): boolean => {
        const state = getEditorStoreState();
        const editorState = getEditorState(state);
        const editorId = getEditorId(state);
        const originalEditorId = getOriginalEditorIdSelector(state);

        if (!editorState) return false;

        const selection = editorState.getSelection();
        if (!selection) return false;

        // If the selection is collapsed, there's nothing to do
        // return false to indicate that this action was not handled
        if (selection.isCollapsed()) return false;

        const newSelection = selection.merge({
            anchorOffset: selection.getAnchorOffset(),
            focusOffset: selection.getAnchorOffset(),
        });

        const updatedEditorState = EditorState.forceSelection(editorState, newSelection);

        dispatch(editorStateChanged({ editorId, originalEditorId, editorState: updatedEditorState }));

        return true;
    };
